/**
 * "Custom endpoints & tool availability" — Dashboard section (ADR-0074).
 * Reconciled from apps/web custom-endpoints + tool-availability features.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_ENDPOINTS_PAGE: DocPageContent = {
  slug: 'dashboard/custom-endpoints',
  titleKey: 'docs.dashboard.endpoints.title',
  descriptionKey: 'docs.dashboard.endpoints.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.endpoints.lead' },

    { kind: 'heading', level: 2, id: 'custom', textKey: 'docs.dashboard.endpoints.custom.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.endpoints.custom.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.endpoints.type.rest',
        'docs.dashboard.endpoints.type.graphql',
        'docs.dashboard.endpoints.type.grpc',
        'docs.dashboard.endpoints.type.webhook',
        'docs.dashboard.endpoints.type.formflow',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'availability',
      textKey: 'docs.dashboard.endpoints.availability.heading',
    },
    { kind: 'paragraph', textKey: 'docs.dashboard.endpoints.availability.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.endpoints.availability.item.simple',
        'docs.dashboard.endpoints.availability.item.advanced',
      ],
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.endpoints.next.catalog.title',
          textKey: 'docs.dashboard.endpoints.next.catalog.text',
          to: { docSlug: 'dashboard/catalog' },
        },
        {
          titleKey: 'docs.dashboard.endpoints.next.prompts.title',
          textKey: 'docs.dashboard.endpoints.next.prompts.text',
          to: { docSlug: 'dashboard/prompts' },
        },
      ],
    },
  ],
};
